import React from 'react';
import { useGetIsLoggedIn } from '@multiversx/sdk-dapp/hooks';
import { logout } from '@multiversx/sdk-dapp/utils';
import clsx from 'clsx';
import { Navbar as BsNavbar, NavItem, Nav, NavDropdown } from 'react-bootstrap';
import { BsFillMenuButtonWideFill } from "react-icons/bs";
import { Link, useLocation } from 'react-router-dom';
import { routeNames } from 'routes';
import logo from 'assets/img/logo.png';
import { useGetAccount } from '@multiversx/sdk-dapp/hooks';
import { ADMIN_ADDRESS } from 'config';

export const Navbar = () => {
  const { address, balance } = useGetAccount();
  const isLoggedIn = useGetIsLoggedIn();
  const handleLogout = () => {
    logout(`${window.location.origin}/unlock`);
  };
  const location = useLocation();

  return (
    <BsNavbar className='EPunk-Header' expand='lg' collapseOnSelect>
      <div className='container-fluid container' style={{ marginTop: "16px" }}>
        <a
          className='d-flex align-items-center navbar-brand mr-0'
          href={"https://jewelswap.io/"}
        >
          <img src={logo} style={{ maxWidth: "200px", width: "200px", height: 'auto' }} />
          {/* <span className='dapp-name text-white'>{dAppName}</span> */}
        </a>

        <BsNavbar.Toggle aria-controls='responsive-navbar-nav' style={{ background: "transparent", border: 'none', fontSize: '1.5rem', color: 'white' }} >
          <BsFillMenuButtonWideFill />
        </BsNavbar.Toggle >

        <BsNavbar.Collapse id='responsive-navbar-nav' className='nav-menu-wrap'>
          <Nav className='ml-auto'>
            {/*<Link to="https://jewelswap.webflow.io/" className={clsx('custom-navbar-button', location.pathname == routeNames.dashboard && 'custom-navbar-button-selected')}>*/}
            {/*  About*/}
            {/*</Link>*/}
            <Link to={routeNames.dashboard} className={clsx('custom-navbar-button', location.pathname == routeNames.dashboard && 'custom-navbar-button-selected')}>
              Overview
            </Link>
            {<Link to={routeNames.collections} className={clsx('custom-navbar-button', location.pathname == routeNames.collections && 'custom-navbar-button-selected')}>
              Collections
            </Link>}
            <Link to={routeNames.lend} className={clsx('custom-navbar-button', location.pathname == routeNames.lend && 'custom-navbar-button-selected')}>
              Lend
            </Link>
            <Link to={routeNames.borrow} className={clsx('custom-navbar-button', location.pathname == routeNames.borrow && 'custom-navbar-button-selected')}>
              Borrow
            </Link>
            <Link to={routeNames.mortgage} className={clsx('custom-navbar-button', location.pathname == routeNames.mortgage && 'custom-navbar-button-selected')}>
              Mortgage
            </Link>
            <Link to={routeNames.farm} className={clsx('custom-navbar-button', location.pathname == routeNames.farm && 'custom-navbar-button-selected')}>
              Farms
            </Link>
            <NavDropdown
              title='Portfolio'
              className={clsx('custom-navbar-button', location.pathname == routeNames.mypositions || location.pathname == routeNames.loans || location.pathname == routeNames.mypools ? 'custom-navbar-button-selected' : '')}
            >
              <NavDropdown.Item><Link to={routeNames.mypositions}>My Positions</Link></NavDropdown.Item>
              <NavDropdown.Item><Link to={routeNames.loans}>My Loans</Link></NavDropdown.Item>
              <NavDropdown.Item><Link to={routeNames.mypools}>My Pools</Link></NavDropdown.Item>
            </NavDropdown>
            <a href="https://docs.jewelswap.io/" className={clsx('custom-navbar-button')} >
              Docs
            </a>
            {/* {ADMIN_ADDRESS == address && (
              <NavDropdown
                title='Admin'
                className={clsx('custom-navbar-button', location.pathname == routeNames.topUp || location.pathname == routeNames.veash ? 'custom-navbar-button-selected' : '')}
              >
                <NavDropdown.Item><Link to={routeNames.topUp}>TopUp</Link></NavDropdown.Item>
                <NavDropdown.Item><Link to={routeNames.veash}>Veash</Link></NavDropdown.Item>
              </NavDropdown>
            )} */}
            <NavDropdown
              title='Admin'
              className={clsx('custom-navbar-button', location.pathname == routeNames.topUp || location.pathname == routeNames.veash ? 'custom-navbar-button-selected' : '')}
            >
              <NavDropdown.Item><Link to={routeNames.topUp}>TopUp</Link></NavDropdown.Item>
              <NavDropdown.Item><Link to={routeNames.veash}>Veash</Link></NavDropdown.Item>
            </NavDropdown>
            {isLoggedIn ? (
              <NavItem>
                <button className='btn btn-link' onClick={handleLogout}>
                  <div className="eg-btn btn--primary2 capsule btn--md" style={{ cursor: 'pointer' }}>Disconnect</div>
                </button>
              </NavItem>
            ) : (
              <Nav.Link href={routeNames.unlock}>
                <div className="eg-btn btn--primary2 capsule btn--md" style={{ cursor: 'pointer' }}>Connect</div>
              </Nav.Link>
            )}
          </Nav>
        </BsNavbar.Collapse>
      </div>
    </BsNavbar>
  );
};
